// Game Service - API calls for game functionality

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Generate game content based on template type
export async function generateGameContent(templateId, topic, moduleTitle, concepts, difficulty = 'intermediate') {
    const response = await fetch(`${API_BASE}/api/generate-game-content/${templateId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ topic, moduleTitle, concepts, difficulty })
    });

    if (!response.ok) {
        throw new Error('Failed to generate game content');
    }

    return response.json();
}

// Get all game templates
export async function getGameTemplates() {
    const response = await fetch(`${API_BASE}/api/game-templates`);
    if (!response.ok) throw new Error('Failed to fetch game templates');
    return response.json();
}

// Get specific game template
export async function getGameTemplate(templateId) {
    const response = await fetch(`${API_BASE}/api/game-templates/${templateId}`);
    if (!response.ok) throw new Error('Failed to fetch game template');
    return response.json();
}

// Create game session
export async function createGameSession(userId, templateId, learningPathId, worldNodeId, gameContent) {
    const response = await fetch(`${API_BASE}/api/game-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, templateId, learningPathId, worldNodeId, gameContent })
    });

    if (!response.ok) throw new Error('Failed to create game session');
    return response.json();
}

// Update game session with results
export async function updateGameSession(sessionId, results, state = 'completed') {
    const response = await fetch(`${API_BASE}/api/game-session/${sessionId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ results, state })
    });

    if (!response.ok) throw new Error('Failed to update game session');
    return response.json();
}

// Calculate rewards based on game performance
export function calculateRewards(template, score, accuracy, timeBonus = 0) {
    const baseXP = template.rewards?.baseXP || 100;
    const bonusPerCorrect = template.rewards?.bonusPerCorrect || 10;
    const perfectBonus = template.rewards?.perfectBonus || 50;

    let xp = baseXP;
    xp += Math.floor(score * bonusPerCorrect);
    xp += timeBonus;

    if (accuracy >= 100) {
        xp += perfectBonus;
    } else if (accuracy >= 90) {
        xp += Math.floor(perfectBonus * 0.5);
    }

    const coins = Math.floor(xp * 0.25);
    const stars = accuracy >= 90 ? 3 : accuracy >= 70 ? 2 : accuracy >= 50 ? 1 : 0;

    return { xp, coins, stars, accuracy };
}

// Shuffle array (Fisher-Yates)
export function shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}

const gameService = {
    generateGameContent,
    getGameTemplates,
    getGameTemplate,
    createGameSession,
    updateGameSession,
    calculateRewards,
    shuffleArray
};

export default gameService;
